import { useCallback } from "react";

import PropTypes from "prop-types";
import {
  Box,
  Divider,
  MenuItem,
  MenuList,
  Popover,
  Typography,
} from "@mui/material";
import useAuth from "../../../hooks/store/auth";
import { useNavigate } from "react-router-dom";

export const AccountPopover = (props) => {
  const { anchorEl, onClose, open } = props;
  const router = useNavigate();
  const auth = useAuth();
  const accountLabel = auth.email || auth.user || "Account";

  const handleSignOut = useCallback(() => {
    onClose?.();
    auth.logoutAction();
    router("/");
  }, [onClose, auth, router]);

  return (
    <Popover
      anchorEl={anchorEl}
      anchorOrigin={{
        horizontal: "left",
        vertical: "bottom",
      }}
      onClose={onClose}
      open={open}
      PaperProps={{ sx: { width: 200 } }}
    >
      <Box
        sx={{
          py: 1.5,
          px: 2,
        }}
      >
        <Typography
          color="text.secondary"
          variant="body2"
          sx={{ paddingLeft: 2.5, fontWeight: 700 }}
        >
          {accountLabel}
        </Typography>
      </Box>
      <Divider />
      <MenuList
        disablePadding
        dense
        sx={{
          p: "8px",
          "& > *": {
            borderRadius: 1,
          },
        }}
      >
        <MenuItem sx={{ paddingLeft: 3.5,color:"red",fontWeight:600 }} onClick={handleSignOut}>Sign out</MenuItem>
      </MenuList>
    </Popover>
  );
};

AccountPopover.propTypes = {
  anchorEl: PropTypes.any,
  onClose: PropTypes.func,
  open: PropTypes.bool.isRequired,
};
